import React from "react";
import banner from "../../asset/rawalpindi banner.png";
import bannerSm from "../../asset/rawalpindi banner sm.png";
import SikhEmpireImage from "../../asset/Sikh Empire.png";
import BritishImage from "../../asset/British.png";
import PartitionImage from "../../asset/Partition.png";
import BritishSmImage from "../../asset/British sm.png";
import PartitionSmImage from "../../asset/Partition sm.png";

const AboutRawalpindi = () => {
  return (
    <div className="flex flex-col gap-10  md:pb-20 pb-10  xl:px-[5%] lg:px-[3%] md:px-[3%] px-[6%]  bg-white md:bg-[#F6F6F6]">
      <div className="xl:py-6 lg:py-4 py-3">
        <img
          className="w-full lg:rounded-2xl rounded-xl md:flex hidden"
          src={banner}
          alt=""
        />
        <img
          className="w-full rounded-xl flex md:hidden"
          src={bannerSm}
          alt=""
        />
      </div>
      <div className=" flex flex-col md:gap-10 gap-6 ">
        <div>
          <p className="md:text-[1.3rem] text-[1rem] text-[#7A7A7A]">
            Rawalpindi is located on the Pothohar Plateau, known for its ancient
            Buddhist heritage, especially in the neighboring town of Taxila – a
            UNESCO World Heritage Site. The city was destroyed during the
            invasion of Mahmud of Ghazni before being taken over by Gakhars in
            1493. In 1765, the ruling Gakhars were defeated as the city came
            under Sikh rule, and eventually became a major city within the Sikh
            Empire based in Lahore. The city was conquered by the British Raj in
            1849, and in 1851 became the largest garrison town of the British
            Indian Army. Following the partition of British India in 1947, the
            city became home to the headquarters of Pakistan Army hence
            retaining its status as a major military city. <br />{" "}
            <br className=" block md:hidden" /> Construction of Pakistan’s new
            purpose-built national capital city of Islamabad in 1961 led to
            greater investment in the city, as well as a brief stint as the
            country’s capital immediately before completion of Islamabad. Modern
            Rawalpindi is socially and economically intertwined with Islamabad,
            and the greater metropolitan area. The city is also home to numerous
            suburban housing developments that serve as bedroom-communities for
            workers in Islamabad. As home to GHQ of Pakistan Army & Benazir
            Bhutto International Airport, and with connections to the M-1 and
            M-2 motorways, Rawalpindi is a major logistics and transportation
            centre for northern Pakistan. The city is also home to historic
            havelis and temples, and serves as a hub for tourists visiting
            Rohtas Fort, Azad Kashmir, Taxila and Gilgit-Baltistan.
          </p>
        </div>
        {/* History */}
        <div className=" flex flex-col gap-3">
          <h1 className="font-semibold  md:text-[2.5rem] text-[1.8rem]">
            History
          </h1>
          <p className="md:text-[1.3rem] text-[1rem] text-[#7A7A7A]">
            The region around Rawalpindi has been inhabited for thousands of
            years. Rawalpindi falls within the ancient boundaries of Gandhara,
            and is in a region littered with Buddhist ruins. In the region
            north-west of Rawalpindi, traces have been found of at least 55
            stupas, 28 Buddhist monasteries, 9 temples, and various artifacts in
            the Kharoshthi script. <br /> <br className=" block md:hidden" /> To
            the southeast are the ruins of the Mankiala stupa – a 2nd-century
            stupa where, according to the Jataka tales, a previous incarnation
            of the Buddha leapt off a cliff in order to offer his corpse to
            seven hungry tiger cubs. The nearby town of Taxila is thought to
            have been home to the world’s first university. Sir Alexander
            Cunningham identified ruins on the site of the Rawalpindi Cantonment
            as the ancient city of Ganjipur (or Gajnipur), the capital of the
            Bhatti tribe in the ages preceding the Christian era.
          </p>
        </div>
        {/* Medieval */}
        <div className=" flex flex-col gap-3">
          <h1 className="font-semibold  md:text-[2.5rem] text-[1.8rem]">
            Medieval
          </h1>
          <p className="md:text-[1.3rem] text-[1rem] text-[#7A7A7A]">
            The first mention of Rawalpindi’s earliest settlement dates from
            when Mahmud of Ghazni destroyed Rawalpindi and the town was restored
            by Gakhar chief Kai Gohar in the early 11th century. The town fell
            into decay again after Mongol invasions in the 14th century.
            Situated along an invasion route, the settlement did not prosper and
            remained deserted until 1493, when Jhanda Khan re-established the
            ruined town, and named it Rawal.
          </p>
        </div>
        {/* Mughal */}
        <div className=" flex flex-col gap-3">
          <h1 className="font-semibold  md:text-[2.5rem] text-[1.8rem]">
            Mughal
          </h1>
          <p className="md:text-[1.3rem] text-[1rem] text-[#7A7A7A]">
            The 16th century Rawat Fort offered military protection to
            Rawalpindi. <br /> <br className=" block md:hidden" /> During the
            Mughal era, Rawalpindi remained under the rule of the Ghakhar clan,
            who in turn pledged allegiance to the Mughal Empire. The city was
            developed as an important outpost in order to guard the frontiers of
            the Mughal realm.Gakhars fortified a nearby caravanserai, in the
            16th century, transforming it into the Rawat Fort in order to defend
            the Pothohar plateau from Sher Shah Suri’s forces. Construction of
            the Attock Fort in 1581 after Akbar led a campaign against his
            brother Mirza Muhammad Hakim, further securing Rawalpindi’s
            environs. In December 1585, the Emperor Akbar arrived in Rawalpindi,
            and remained in and around Rawalpindi for 13 years as he extended
            the frontiers of the empire, in an era described as a “glorious
            period” in his career as Emperor. <br />{" "}
            <br className=" block md:hidden" />
            With the onset of chaos and rivalry between Gakhar chiefs after the
            death of Kamal Khan in 1559, Rawalpindi was awarded to Said Khan by
            the Mughal Emperor. The Emperor Jehangir visited the royal camp in
            Rawalpindi in 1622, where he first learned of Shah Abbas I of
            Persia’s plan to invade Kandahar.
          </p>
        </div>
        {/* Sikh Misl */}
        <div className=" flex flex-col gap-3">
          <h1 className="font-semibold  md:text-[2.5rem] text-[1.8rem]">
            Sikh Misl
          </h1>
          <p className="md:text-[1.3rem] text-[1rem] text-[#7A7A7A]">
            Rawalpindi declined in importance as Mughal power declined, until
            the town was captured in the mid 1760s from Muqarrab Khan by the
            Sikhs under Sardar Gujjar Singh and his son Sahib Singh. The city’s
            administration was handed to Sardar Milkha Singh, who then invited
            traders from the neighboring commercial centers of Jhelum and
            Shahpur to settle in the territory in 1766.The city then began to
            prosper, although the population in 1770 is estimated to have been
            only about 300 families. Rawalpindi became for a time the refuge of
            Shah Shuja, the exiled king of Afghanistan, and of his brother Shah
            Zaman in the early 19th century.
          </p>
        </div>
        {/* Sikh Empire */}
        <div className=" flex items-center md:flex-row flex-col-reverse  lg:gap-12 gap-6">
          <div className=" flex flex-col gap-3 lg:w-[60%] md:w-[50%] w-full">
            <h1 className="font-semibold  md:text-[2.5rem] text-[1.8rem]">
              Sikh Empire
            </h1>
            <p className="md:text-[1.3rem] text-[1rem] text-[#7A7A7A]">
              Sikh ruler Maharaja Ranjit Singh allowed the son of Sardar Milkha
              Singh to continue as Governor of Rawalpindi, after Ranjit Singh
              seized the district in 1810. Sikh rule over Rawalpindi was
              consolidated by defeat of the Afghans at Haidaran in July 1813 The
              Sikh rulers allied themselves with some of the local Gakhar
              tribes, and jointly defeated Syed Ahmad Barelvi at Akora Khattak
              in 1827, and again in 1831 in Balakot. Jews first arrived in
              Rawalpindi’s Babu Mohallah neighbourhood from Mashhad, Persia in
              1839, in order to flee from anti-Jewish laws instituted by the
              Qajar dynasty. In 1841, Diwan Kishan Kaur was appointed Sardar of
              Rawalpindi. <br /> <br className=" block md:hidden" /> On 14 March
              1849, Sardar Chattar Singh and Raja Sher Singh of the Sikh Empire
              surrendered to General Gilbert near Rawalpindi, ceding the city to
              the British. The Sikh Empire then came to an end on 29 March 1849.
            </p>
          </div>
          <div className=" lg:w-[40%] md:w-[50%] w-full">
            <img
              src={SikhEmpireImage}
              className=" lg:rounded-2xl rounded-xl"
              alt=""
            />
          </div>
        </div>
        {/* British */}
        <div className="flex flex-col gap-3">
          <h1 className="font-semibold  md:text-[2.5rem] text-[1.8rem]">
            British
          </h1>
          <p className="md:text-[1.3rem] text-[1rem] text-[#7A7A7A]">
            Rawalpindi’s Fatima Jinnah Women University is housed in a Victorian
            mansion. <br /> Following Rawalpindi’s capture by the British East
            India company, 53rd Regiment of the company army took quarters in
            the newly captured city. The decision to man a permanent military
            cantonment in the city was made in 1851 by the Marquess of
            Dalhousie. The city saw its first telegraph office in the early
            1850s. The city’s Garrison Church was built shortly after in 1854,
            and is the site where Robert Milman, Bishop of Calcutta, was buried
            following his death in Rawalpindi in 1876. The city was home to
            15,913 people in the 1855 census. During the 1857 Sepoy Mutiny, the
            area’s Gakhars and Janjua tribes remained loyal to the British.
          </p>

          <img
            className="w-full lg:rounded-2xl rounded-xl lg:my-14 my-8 md:flex hidden"
            src={BritishImage}
            alt=""
          />
          <img
            className="w-full rounded-xl flex md:hidden my-6"
            src={BritishSmImage}
            alt=""
          />
          <p className="md:text-[1.3rem] text-[1rem] text-[#7A7A7A]">
            Rawalpindi flourished as a commercial centre, though the city
            remained largely devoid of an industrial base during the British
            era. A large portion of Kashmir’s external trade passing through the
            city; in 1885, 14% of Kashmir’s exports, and 27% of its imports
            passed through the city. A large market was opened in central
            Rawalpindi in 1883 by Sardar Sujan Singh, while the British further
            developed a shopping district for the city’s elite known as Saddar
            with an archway built to commemorate Brigadier General Massey.{" "}
            <br /> <br className=" block md:hidden" /> Rawalpindi’s cantonment
            became a major center of military power of the Raj after an arsenal
            was established in 1883. Britain’s army elevated the city from a
            small town, to the third largest city in Punjab by 1921. In 1868,
            9,358 people lived in the city’s cantonment – by 1891, the number
            rose to 37,870. In 1891, the city’s population excluding the
            Cantonment was 34,153. The city was considered to be a favourite
            first posting for newly arrived soldiers from England, owing to the
            city’s agreeable climate, and nearby hill station at nearby Murree.
            In 1901, Rawalpindi was made the winter headquarters of the Northern
            Command and of the Rawalpindi military division. Riots broke out
            against British rule in 1905, following a famine in Punjab that
            peasants were led to believe was a deliberate act. <br />{" "}
            <br className=" block md:hidden" /> During World War 1, Rawalpindi
            District “stood first” among districts in recruiting for the British
            war effort, with greater financial assistance from the British
            government channeled into the area in return. By 1921, Rawalpindi’s
            cantonment had overshadowed the city – Rawalpindi was one of seven
            cities of Punjab in which over half the population lived in the
            cantonment district. Communal riots erupted between Rawalpindi’s
            Sikh and Muslim communities in 1926 after Sikhs refused to silence
            music from a procession that was passing in front of a mosque.{" "}
            <br /> <br className=" block md:hidden" /> HMS Rawalpindi was
            launched as an ocean liner in 1925 by Harland and Wolff, the same
            company which built RMS Titanic. The ship was converted into an
            armed vessel, and was sunk in October 1939. The British government
            carried out poison gas testing on Indian troops during the
            Rawalpindi experiments over the course of more than a decade
            beginning in the 1930s.
          </p>
        </div>
        {/* Partition */}
        <div className="flex flex-col gap-3">
          <h1 className="font-semibold  md:text-[2.5rem] text-[1.8rem]">
            Partition
          </h1>
          <p className="md:text-[1.3rem] text-[1rem] text-[#7A7A7A]">
            On 5 March 1947, members of Rawalpindi’s Hindu and Sikh communities
            took out a procession against the formation of a Muslim ministry
            within the Government of Punjab. Policemen fired upon protestors,
            while Hindus and Sikhs fought against weaker Muslim
            counter-protestors. The area’s first Partition riots erupted the
            next day on 6 March 1947, when the city’s Muslims, angered by the
            actions of Hindus and Sikhs and encouraged by the Pir of Golra
            Sharif, raided nearby villages after they were unable to do so in
            the city on account of Rawalpindi’s heavily armed Sikhs. <br />{" "}
            <br className=" block md:hidden" />
            At the dawn of Pakistan’s independence in 1947 following the success
            of the Pakistan Movement, Rawalpindi was a 43.79% Muslim, while
            Rawalpindi District as a whole was 80% Muslim. The region, on
            account of its large Muslim majority, was thus awarded to Pakistan.
            Rawalpindi’s Hindu and Sikh population, who had made up 33.72% and
            17.32% of the city, migrated en masse to the newly independent
            Dominion of India after communal riots in western Punjab, while
            Muslim refugees from India settled in the city following anti-Muslim
            pogroms in eastern Punjab and northern India.
          </p>

          <img
            className="w-full lg:rounded-2xl rounded-xl lg:my-14 my-8 md:flex hidden"
            src={PartitionImage}
            alt=""
          />
          <img
            className="w-full rounded-xl flex md:hidden my-6"
            src={PartitionSmImage}
            alt=""
          />
          <p className="md:text-[1.3rem] text-[1rem] text-[#7A7A7A]">
            In 1951, the Rawalpindi conspiracy took place in which leftist army
            officers conspired to depose the first elected Prime Minister of
            Pakistan, Liaquat Ali Khan. Rawalpindi later became the site of the
            Liaquat Ali Khan’s assassination, in what is now known as Liaquat
            Bagh Park. In 1958, Field Marshal Ayub Khan launched his coup d’etat
            from Rawalpindi. In 1959, the city became the interim capital of the
            country under Ayub Khan, who had sought the creation of a new
            planned capital of Islamabad in the vicinity of Rawalpindi. As a
            result, Rawalpindi saw most major central government offices and
            institutions relocate to nearby territory, and its population
            rapidly expand. <br /> <br className=" block md:hidden" />{" "}
            Construction of Pakistan’s new capital city of Islamabad in 1961 led
            to greater investment in Rawalpindi. Rawalpindi remained the
            headquarters of the Pakistani Army after the capital shifted to
            Islamabad in 1969, while the Pakistan Air Force continues to
            maintain an airbase in the Chaklala district of Rawalpindi. The
            military dictatorship of General Zia ul Haq hanged Pakistan’s
            deposed Prime Minister, Zulfikar Ali Bhutto, in Rawalpindi in 1979.{" "}
            <br /> <br className=" block md:hidden" /> In 1980, tens of
            thousands of Shia protestors led by Mufti Jaffar Hussain marched on
            Rawalpindi to protest a provision of Zia ul Haqs Islamization
            programme. A spate of bombings in September 1987 took place in the
            city killing 5 people, in attacks that are believed to have been
            orchestrated by agents of Afghanistan’s communist government.
            <br /> <br className=" block md:hidden" /> Modern Rawalpindi is
            socially and economically intertwined with Islamabad, and the
            greater metropolitan area. The city is also home to numerous
            suburban housing developments that serve as bedroom-communities for
            workers in Islamabad. In June 2015, the Rawalpindi-Islamabad
            Metrobus, a new bus rapid transit line with various points in
            Islamabad, opened for service.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutRawalpindi;
